import { lazyWithRetry } from "utils";

export const AuthorizationDetails = lazyWithRetry(() => import("./containers"));